import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import React from 'react';
import ArrTooltipWrapper from '../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from '../../../../assets/images/info-icon.svg';

type SelectionHeaderProps = {
  isNextButtonDisabled?: boolean;
};

const SelectionHeader: React.FC<SelectionHeaderProps> = ({
  isNextButtonDisabled,
}) => {
  return (
    <Box component="section">
      <Box className="ingestion-wizard-selection">
        <Box className="selection-title-sub">
          <Typography
            className="selection-heading-title typo-text subhead2_size"
            id="selection-section-title"
            tabIndex={0}
            onKeyDown={(e: any) => {
              if (e.key === 'Tab' && e.shiftKey) {
                e.preventDefault();
                (
                  document.querySelector(
                    '[data-testid="save-draft-button"]'
                  ) as HTMLElement
                )?.focus();
              }
            }}
            data-testid={`selection-header-selection`}
          >
            {t('ingestions.Wizard.Selection')}
          </Typography>
          <ArrTooltipWrapper
            title={t('ingestions.Wizard.Selection')}
            closeTooltipOnEscPress
            triggerKeyDownOnTab
            trigger={
              <InfoIcon
                fontSize="medium"
                className="view-ingestion-wizard-info-icon"
                aria-label={t(
                  'ingestions.Wizard.ariaLabels.selectionHeader.infoIcon'
                )}
                data-testid="source-selection-info-icon"
                tabIndex={0}
                onKeyDown={(e: any) => {
                  const dataTestId = isNextButtonDisabled
                    ? 'inactive-next-button'
                    : 'next-button';
                  if (e.key === 'Tab' && e.shiftKey) {
                    return;
                  }
                  if (e.key === 'Tab') {
                    e.preventDefault();
                    (
                      document.querySelector(
                        `[data-testid=${dataTestId}]`
                      ) as HTMLElement
                    )?.focus();
                  }
                }}
              />
            }
          >
            <Box className="ingestion-tooltip-content-box">
              <p
                className="tooltip-content typo-text body2_size "
                data-testid={`selection-header-overview`}
                tabIndex={0}
              >
                {t('ingestions.Wizard.selectionWizard.overview')}
              </p>
              <Typography
                className="tooltip-heading typo-text subhead3_size"
                tabIndex={0}
                data-testid={`selection-header-source-location-text`}
              >
                {t(
                  'ingestions.Wizard.sourceLocationSection.sourceLocationText'
                )}
              </Typography>
              <p
                className="tooltip-content typo-text body2_size "
                data-testid={`selection-header-source-location`}
                tabIndex={0}
              >
                {t('ingestions.Wizard.selectionWizard.sourceLocation')}
              </p>
              <Typography
                className="tooltip-heading typo-text subhead3_size"
                tabIndex={0}
                data-testid={`selection-header-dat-title`}
              >
                {t('ingestions.Wizard.selectionWizard.datTitle')}
              </Typography>
              <p
                className="tooltip-content typo-text body2_size "
                tabIndex={0}
                data-testid={`selection-header-dat-content`}
              >
                {t('ingestions.Wizard.selectionWizard.datContent')}
              </p>
              <Typography
                className="tooltip-heading typo-text subhead3_size"
                tabIndex={0}
                data-testid={`selection-header-date-title`}
              >
                {t('ingestions.Wizard.selectionWizard.dateTitle')}
              </Typography>
              <p
                className="tooltip-content typo-text body2_size "
                tabIndex={0}
                data-testid={`selection-header-date-content`}
              >
                {t('ingestions.Wizard.selectionWizard.dateContent')}
              </p>
              <Typography
                className="tooltip-heading typo-text subhead3_size"
                tabIndex={0}
                data-testid={`selection-header-ingestion-title`}
              >
                {t('ingestions.Wizard.selectionWizard.ingestionTitle')}
              </Typography>
              <div tabIndex={0}>
                <p
                  className="tooltip-content typo-text body2_size "
                  data-testid={`selection-header-ingestion-content1`}
                >
                  {t('ingestions.Wizard.selectionWizard.ingestionContent1')}
                </p>
                <p
                  className="tooltip-content typo-text body2_size "
                  data-testid={`selection-header-ingestion-content2`}
                >
                  {t('ingestions.Wizard.selectionWizard.ingestionContent2')}
                </p>
                <p
                  className="tooltip-content typo-text body2_size "
                  data-testid={`selection-header-ingestion-content3`}
                >
                  {t('ingestions.Wizard.selectionWizard.ingestionContent3')}
                </p>
              </div>
            </Box>
          </ArrTooltipWrapper>
        </Box>
      </Box>
      <Typography
        className="typo-text body2_size view-ingestionSummary-title-text"
        role="note"
        aria-live="polite"
        id="ingestion-overlay-description"
        tabIndex={0}
        onKeyDown={(e: any) => {
          const dataTestId = isNextButtonDisabled
            ? 'inactive-next-button'
            : 'next-button';

          if (e.key === 'Tab' && isNextButtonDisabled) {
            const el = document.querySelector(
              `[data-testid=${dataTestId}]`
            ) as HTMLElement;
            el.setAttribute('tabIndex', '-1');
          }

          if (e.key === 'Tab' && e.shiftKey) {
            e.preventDefault();
            (
              document.querySelector(
                `[data-testid=${dataTestId}]`
              ) as HTMLElement
            )?.focus();
            return;
          }
        }}
        data-testid={`selection-header-overlay`}
      >
        {t('ingestions.Wizard.overlay')}
      </Typography>
    </Box>
  );
};

export default SelectionHeader;
